module.exports = __webpack_public_path__ + "static/label-d13171b9d71194948e169f5caa7bba66.png";